import { useContext, useEffect } from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";

import Loader        from "./loader";
import { observer }  from "mobx-react-lite";
import { AppStoreContext } from "../store/app-store";
import { StatusEnum } from "../models/enums/status.enum";
import { HOME }       from "../constants/routes";
import {initApp} from "../routes/initialise-application.ts";

const Root = observer(() => {
  const store = useContext(AppStoreContext);

  const navigate  = useNavigate();
  const location  = useLocation();

    useEffect(() => {
        const refreshState = async () => {
            console.log('Root: Starting app initialization...');
            try {
                const refreshedState = await initApp();
                console.log('Root: App initialized successfully', {
                    status: refreshedState.status,
                    hasContext: !!refreshedState.context,
                    contextKeys: Object.keys(refreshedState.context || {}),
                    messagesCount: Object.keys(refreshedState.messages || {}).length,
                    customerDefaultLanguage: refreshedState.context.customerDefaultLanguage
                });
                store.setInitState(refreshedState);
            } catch (error) {
                console.error('Root: App initialization failed', error);
                throw error;
            }
        };
        refreshState();
    }, [store]);

  useEffect(() => {
    console.log('Root: Navigation check', {
      status: store.status,
      pathname: location.pathname
    });
    if (store.status === StatusEnum.PAIRED && location.pathname === "/") {
      console.log('→ Navigating to HOME');
      navigate(HOME, { replace: true });
    }
    if (store.status === StatusEnum.UNPAIRED && location.pathname !== "/") {
      console.log('→ Navigating to root');
      navigate("/", { replace: true });
    }
  }, [store.status, location.pathname, navigate]);

  const isLoading = Object.keys(store.context || {}).length === 0 || Object.keys(store.messages || {}).length === 0;

  console.log('Root: Render check', {
    isLoading,
    contextKeysCount: Object.keys(store.context || {}).length,
    messagesKeysCount: Object.keys(store.messages || {}).length
  });

  return isLoading ? <Loader /> : <Outlet />;
});

export default Root;
